import { render, staticRenderFns } from "./MoleculeEscalationItem.vue?vue&type=template&id=9a825542&scoped=true&"
import script from "./MoleculeEscalationItem.vue?vue&type=script&lang=js&"
export * from "./MoleculeEscalationItem.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeEscalationItem.vue?vue&type=style&index=0&id=9a825542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a825542",
  null
  
)

export default component.exports